export const baseUrl = "https://api.darikacademy.com";
// export const baseUrl = "http://192.168.10.112:8000";
